import { ThemeToggle } from "../lib/ThemeToggle";

export function TopBar() {
  return (
    <header className="topbar">
      <a className="wordmark" href="/#top">
        <img
          className="wordmark__avatar"
          src="/images/adi-kishore.jpg"
          alt="Adi Kishore"
        />
        Adi Kishore
      </a>
      <nav className="topbar__nav">
        <a href="/#work">Work</a>
        <a href="/#index">Index</a>
        <a href="/#about">About</a>
        <a href="mailto:kishek12@gmail.com">Contact</a>
      </nav>
      <div className="topbar__right">
        <ThemeToggle />
      </div>
    </header>
  );
}
